import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a9743a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Wysłane!", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "gray" }, [
  /*#__PURE__*/_createTextVNode(" Dzięki!"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Zweryfikujemy informacje od Ciebie i uzupełnimy je w naszym serwisie. ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "gray" }, " Jeśli jesteś zalogowany, powiadomimy Cię o naszych działaniach. ", -1))
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "improvement-form-header" }
const _hoisted_8 = { class: "subheader mb-3" }
const _hoisted_9 = { class: "d-flex justify-content-between mt-5" }
const _hoisted_10 = { class: "text-box-header" }
const _hoisted_11 = {
  key: 0,
  class: "error"
}
const _hoisted_12 = {
  for: "file-upload",
  class: "my-file-upload mb-3"
}
const _hoisted_13 = {
  key: 0,
  class: "bold"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Usługa jest całkowicie "),
  /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "darmowa"),
  /*#__PURE__*/_createTextVNode(". "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Nie zapomnij napisać jaki masz samochód. ")
], -1))
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Podaj swój adres email - na który będziemy mogli przesłać odpowiedź. ", -1))
const _hoisted_18 = {
  key: 0,
  class: "error"
}
const _hoisted_19 = { class: "form-group mt-2 d-flex align-items-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "rights",
  class: "ms-2"
}, "Wyrażam zgodę na przetwarzanie moich danych osobowych zgodnie z Polityką Prywatności", -1))
const _hoisted_21 = {
  key: 2,
  class: "error"
}
const _hoisted_22 = { class: "d-flex justify-content-center mt-2" }
const _hoisted_23 = {
  key: 3,
  class: "d-flex justify-content-between phone mb-4",
  href: "tel:{getPhoneNUmber}"
}
const _hoisted_24 = { class: "btn-gradient phone-button" }
const _hoisted_25 = { class: "ms-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "comfortaa mb-0" }, "Wolisz rozmawiać?", -1))
const _hoisted_27 = { class: "blue mt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_camera_icon = _resolveComponent("camera-icon")!
  const _component_loading = _resolveComponent("loading")!
  const _component_phone_icon = _resolveComponent("phone-icon")!

  return (_ctx.success)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.formData.header), 1),
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.formData.subheader), 1),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.formData.textBoxHeader), 1),
          _createVNode(_component_tool_tip, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formData.hoverText), 1)
            ]),
            _: 1
          })
        ]),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.content) = $event)),
          class: _normalizeClass(["mb-2", { 'is-invalid': _ctx.contentError }])
        }, null, 2), [
          [_vModelText, _ctx.content]
        ]),
        (_ctx.contentError)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.contentError), 1))
          : _createCommentVNode("", true),
        _createElementVNode("label", _hoisted_12, [
          (_ctx.file)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.file.name), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_14, "możesz też dodać zdjęcie/pdf")),
          _createVNode(_component_camera_icon)
        ]),
        _createElementVNode("input", {
          accept: "image/*,.pdf",
          type: "file",
          id: "file-upload",
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFileChanged && _ctx.onFileChanged(...args)))
        }, null, 32),
        _hoisted_15,
        (!_ctx.user)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.emailError }]),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                placeholder: "twoj-adres@email.com"
              }, null, 2), [
                [_vModelText, _ctx.email]
              ]),
              (_ctx.emailError)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.emailError), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_19, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  name: "rights",
                  id: "rights",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.emailConsent) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.emailConsent]
                ]),
                _hoisted_20
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("p", null, _toDisplayString(_ctx.error), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_22, [
          (_ctx.isSend)
            ? (_openBlock(), _createBlock(_component_loading, { key: 0 }))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "button-gradient send",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSendForm && _ctx.handleSendForm(...args)))
              }, " Wyślij "))
        ]),
        (_ctx.formData.phoneButton)
          ? (_openBlock(), _createElementBlock("a", _hoisted_23, [
              _createElementVNode("button", _hoisted_24, [
                _createVNode(_component_phone_icon)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.getPhoneNumber) + " - w godzinach 10 - 16", 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
}